import React from "react";
import RecommendationCard from "./RecommendationCard";
import { Link } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";

const RecommendationSection = ({ title, data, loading, viewType }) => {
  const viewAllPath = title === "Pending Recommendations"
    ? "/pending_requests"
    : "/bosses";

  return (
    <div style={{
      backgroundColor: "#fff",
      borderRadius: "12px",
      padding: "clamp(16px, 3vw, 24px)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
      minHeight: "300px",
      display: "flex",
      flexDirection: "column"
    }}>
      <div style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "clamp(12px, 2vw, 16px)",
        gap: "8px",
        flexWrap: "wrap",
        borderBottom: "1px solid #A1A1A1",
        paddingBottom: "clamp(12px, 2vw, 16px)",
      }}>
        <h2 style={{
          fontSize: "clamp(16px, 2.5vw, 20px)",
          fontWeight: "600",
          margin: 0,
          fontFamily: "Urbanist",
        }}>{title}</h2>
        <Link
          to={viewAllPath}
          style={{
            color: "#000000",
            textDecoration: "underline",
            fontSize: "clamp(12px, 2vw, 14px)",
            fontWeight: "500",
            fontFamily: "Urbanist",
            whiteSpace: "nowrap"
          }}
        >
          View All
        </Link>
      </div>

      {loading ? (
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: 1,
          padding: "32px"
        }}>
          <CircularProgress size={32} color="inherit" sx={{ color: "#12188A" }} />
        </div>
      ) : data.length > 0 ? (
        <div style={{
          display: "flex",
          flexDirection: "column",
          gap: "clamp(8px, 2vw, 16px)"
        }}>
          {data.map((item, index) => (
            <RecommendationCard
              key={index}
              {...item}
              viewType={viewType}
              style={{
                '@media (max-width: 480px)': {
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  gap: '8px'
                }
              }}
            />
          ))}
        </div>
      ) : (
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: 1,
          color: "#64748b",
          fontSize: "clamp(12px, 2vw, 14px)",
          textAlign: "center",
          padding: "clamp(16px, 4vw, 32px)"
        }}>
          No recommendations found
        </div>
      )}
    </div>
  );
};

export default RecommendationSection;